/* eslint-disable no-console */
/**
 * 数美
 * https://toca.17u.cn/wiki?fid=1b7bd80d47154cd89847a36a4429c2a4
 */
import { getCookie, getPlatform } from '@overseas/utool'
import { request } from '@overseas/request'

let isProd = true
let smDeviceId = ''

const FP_TOKEN_KEY = 'fpToken'

function setCookie(cname: string, cvalue: string, exdays?: number) {
  const d = new Date()
  let expires = ''
  let domain = ''
  if (exdays) {
    d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000)
    expires = `expires=${d.toUTCString()}`
  }
  if (location.hostname.includes('hopegoo.com')) {
    domain = '.hopegoo.com'
  }
  document.cookie = `${cname}=${cvalue};${expires};path=/;domain=${domain}`
}

function getLocalToken() {
  return decodeURIComponent(getCookie(FP_TOKEN_KEY) || '')
}

function setLocalToken(fpToken: string) {
  // const domain = location.hostname.includes('hopegoo.com') ? '.hopegoo.com' : '';
  setCookie(FP_TOKEN_KEY, encodeURIComponent(fpToken))
  smDeviceId = fpToken
}
/**
 * cb业务逻辑
 * 使用数美设备标识逻辑
 */
function dealSmDeviceId(): Promise<{ fpToken: string }> {
  return new Promise((resolve) => {
    if (typeof window === 'undefined') {
      return resolve({ fpToken: '' })
    }

    if (smDeviceId) {
      return resolve({ fpToken: smDeviceId })
    }

    smDeviceId = getLocalToken()
    if (smDeviceId) {
      return resolve({ fpToken: smDeviceId })
    }

    (window as any).SMSdk.ready(() => {
      if ((window as any).SMSdk.getDeviceId) {
        smDeviceId = (window as any).SMSdk.getDeviceId()
      }
      setLocalToken(smDeviceId)
      resolve?.({ fpToken: smDeviceId })
    })
  })
}

// const anonymousUpload = false;

export function trackSmFingerprint({
  sectoken,
}: {
  sectoken?: string
}): Promise<void> {
  if (import.meta.server) {
    return Promise.resolve()
  }

  const isLogin = getCookie('sectoken') || getCookie('us')
  if (!isLogin) {
    console.warn('数美设备指纹上报仅在登录后进行')
    return Promise.resolve()
  }

  return dealSmDeviceId().then(({ fpToken }) => {
    if (!fpToken) {
      console.warn('数美设备指纹未获取到，无法上报')
      return
    }
    const fpTokenCookie = getLocalToken()
    console.log('数美设备指纹上报:', fpToken, fpTokenCookie)
    // 调用设备指纹上报接口，cookie和clientInfo都传了，cookie用于跨项目，clientInfo兼容跨域场景
    return deviceFingerprintUploadPost({} as any, {
      sectoken,
      needFpToken: true,
    }).catch((err) => {
      console.error('数美设备指纹上报失败:', err)
    })
  })
}

export function useSMFingerprint() {
  const runtimeConfig = useRuntimeConfig()
  isProd = ['stage', 'qa', 'dev'].includes(runtimeConfig.public.envType) === false
  const userAgent = import.meta.client
    ? (navigator.userAgent || '')
    : (useRequestHeaders()?.['user-agent'] || '')

  const platform = getPlatform(userAgent).toLowerCase()
  const appId = platform === 'hopegoo' ? '20000' : platform === 'wx' ? '20004' : platform === 'm' ? '20003' : '20002'

  // https://rcdatarec.hopegoo.com
  const _smConf = {
    organization: '66YyD5mrVHmgkG7kbADU', // 必填，组织标识，邮件中organization项
    appId, // 必填，应用标识，默认传值default，其他应用标识提前联系数美协助定义
    publicKey:
      'MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQC9c5pPMHFAyzhH7BXFzkbmyRDqyxWEgAZfH2HIfJfjOPk2IuAGhdn3a1AQ9hYWlMmXmA1dzozaOEzIyNnsaYjfxw4CWOgMgCejAodP8jlBbneU/cdqPm7gzItEnkDAH8wHokB8Rd48fAxlemZh1A3sm5RkiWrMRTBV7k3ItlNNlwIDAQAB', // 必填，私钥标识，邮件中publicKey项
    staticHost: 'static.portal101.cn', // 必填, 设置JS-SDK文件域名，建议填写static.portal101.cn
    protocol: 'https', // 如果使用https，则设置，如不使用，则不设置这个字段
    apiHost: 'rcdatarec.hopegoo.com/sm/device/js',
  }

  useHead({
    script: [
      {
        innerHTML: `
        window._smReadyFuncs = [];
        window.SMSdk = {
            onBoxDataReady: function (boxData) {
                console.log('onBoxDataReady', boxData);
            },
            ready: function (fn) {
                fn && _smReadyFuncs.push(fn);
            }
        };
        window._smConf = ${JSON.stringify(_smConf)};
        `,
        tagPosition: 'head',
      },
      {
        src: `//${_smConf.staticHost}/dist/web/v3.0.0/fp.min.js`,
        tagPosition: 'bodyOpen',
      },
    ],
  })
}

function deviceFingerprintUploadPost(root: object, params: any = {}) {
  return request<any>({
    baseUrl: !isProd ? 'https://www.t.hopegoo.com' : 'https://www.hopegoo.com',
    url: '/sea_shell/sea_octopus_api/device/hopegooMessage',
    data: root,
    ...params,
  })
}
